module.exports = __webpack_public_path__ + "img/Quiet-Cove-019.d2b1ed7f.jpg";